import { createFileRoute } from "@tanstack/react-router";
import landingCss from "../landing.css?url";
import legalCss from "../legal.css?url";
import { LegalPage } from "../legal/LegalPage";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy - Salesko" },
      {
        name: "description",
        content:
          "How Salesko collects, uses, and protects your information, including Google user data handled under the Google API Services User Data Policy."
      },
      { property: "og:title", content: "Salesko - Privacy Policy" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://salesko.ai/privacy" }
    ],
    links: [
      { rel: "canonical", href: "https://salesko.ai/privacy" },
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
      },
      { rel: "stylesheet", href: landingCss },
      { rel: "stylesheet", href: legalCss }
    ]
  }),
  component: () => <LegalPage doc="privacy" />
});
